import {
    Box,
    Button,
    Flex,
    FormControl,
    FormLabel,
    Heading,
    Icon,
    Input,
    InputGroup,
    InputRightElement,
    Text,
    useColorModeValue,
  } from "@chakra-ui/react";
  import { useState } from "react";
  import { ViewIcon, ViewOffIcon } from "@chakra-ui/icons";
  
  function ResetPasswordInput({
    password,
    confirmPassword,
    setPassword,
    setConfirmPassword,
    errors,
    onSubmit,
  }) {
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  
    const titleColor = useColorModeValue("teal.300", "teal.200");
    const textColor = useColorModeValue("gray.400", "white");
  
    return (
      <Flex position="relative" mb="40px" justifyContent="center">
        <Flex
          direction="column"
          w={{ base: "100%", md: "50%", lg: "42%" }}
          background="transparent"
          p="48px"
          mt={{ md: "100px", lg: "80px" }}
        >
          <Heading color={titleColor} fontSize="32px" mb="10px">
            Επαναφορά Κωδικού
          </Heading>
          <Text mb="36px" ms="4px" color={textColor} fontWeight="bold" fontSize="14px">
            Δημιουργήστε νέο κωδικό για τον λογαριασμό σας
          </Text>
  
          {/* Password */}
          <FormControl isInvalid={errors.password}>
            <FormLabel fontSize="sm" fontWeight="normal">Κωδικός</FormLabel>
            <InputGroup>
              <Input
                borderRadius="15px"
                mb="24px"
                fontSize="sm"
                type={showPassword ? "text" : "password"}
                placeholder="Νέος κωδικός"
                size="lg"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              <InputRightElement pr="3" cursor="pointer" onClick={() => setShowPassword(!showPassword)}>
                <Icon as={showPassword ? ViewIcon : ViewOffIcon} w={5} h={5} color="gray.500" />
              </InputRightElement>
            </InputGroup>
            {errors.password && <Text color="red.500">{errors.password}</Text>}
          </FormControl>
  
          {/* Confirm Password */}
          <FormControl isInvalid={errors.confirmPassword}>
            <FormLabel fontSize="sm" fontWeight="normal">Επιβεβαίωση Κωδικού</FormLabel>
            <InputGroup>
              <Input
                borderRadius="15px"
                mb="36px"
                fontSize="sm"
                type={showConfirmPassword ? "text" : "password"}
                placeholder="Επαλήθευσε τον κωδικό"
                size="lg"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
              />
              <InputRightElement pr="3" cursor="pointer" onClick={() => setShowConfirmPassword(!showConfirmPassword)}>
                <Icon as={showConfirmPassword ? ViewIcon : ViewOffIcon} w={5} h={5} color="gray.500" />
              </InputRightElement>
            </InputGroup>
            {errors.confirmPassword && <Text color="red.500">{errors.confirmPassword}</Text>}
          </FormControl>
  
          <Button
            fontSize="sm"
            bg="teal.300"
            w="100%"
            h="45"
            color="white"
            mt="20px"
            onClick={onSubmit}
            _hover={{ bg: "teal.200" }}
            _active={{ bg: "teal.400" }}
          >
            Επαναφορά Κωδικού
          </Button>
        </Flex>
      </Flex>
    );
  }
  
  export default ResetPasswordInput;
  